<article class="container block-nav section-outset-y" *ngIf="block.navItems">
  <section class="row">
    <div class="col-lg-5">
      <span class="subtitle-label mb-4" *ngIf="block.title" [innerHTML]="block.title | highlight"></span>
    </div>

    <div class="col-lg-7">
      <ul class="navigation-list">
        <li *ngFor="let item of block.navItems">
          <fstr-link
            [button]="{ text: item.title, url: item.url || '', routerLink: item.routerLink }"
            [routerLinkActive]="'is--current'"
            [routerLinkActiveOptions]="{ exact: item.url === '/' }"
            class="block-nav__link"
          >
            <fstr-icon anchor="icon-arrow-right" class="chip chip--secondary"></fstr-icon>
            <h3 class="mb-0 text-dark block-nav__link__title">{{ item.title }}</h3>
          </fstr-link>
        </li>
      </ul>
    </div>
  </section>
</article>
